import Event from '../Event';

/**
 * Earnings event
 */
class EarningsEvent extends Event {
	/**
	 * Overrides abstract method in Event class. Sets default params for this event
	 * @returns {object} object with event information
	 * @override
	 * @private
	 */
	getDefaultParams() {
		return {
			id: 'earnings',
			name: 'Earnings',
			description: 'description',
			inputs: [{ name: 'includeextraordinary', value: 1 }]
		};
	}
	/**
	 * Overrides abstract method in Event class. Sets default render params for this event
	 * @param {object} data - Symbol data
	 * @override
	 */
	render(data) {
		this.renderDefault(data, 'earnings', '#99F997', 'E');
	}
}

export default EarningsEvent;
